import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService } from '../../base.service';
import { ConfigService } from '../../config.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  // loginform: any = {};

  loginobj: any = {
    username: "",
    password: ""
  };




  constructor(public _baseService: BaseService, public _config: ConfigService) {
  }


  ngOnInit() {

  }


  login() {

    if (this.loginobj.username == "Admin" && this.loginobj.password == "admin@123") {

      this._baseService.showSuccess('logged in successfully...!');

      localStorage.setItem('token', 'sugu123');

      this._baseService.redirectTo('dashboard');
    }
    else {
      this._baseService.showError('Invalid username or Password!');

    }


  }



}
